/**
 * 格式化错误信息，收集错误发生时的上下文数据
 * 支持服务器端和客户端环境
 * @param error 错误对象
 * @param customParams 自定义附加参数
 * @returns 格式化后的错误信息对象
 */
// 从 Nuxt 导入相关函数
import { useRequestEvent, useRequestHeaders } from '#imports'

/**
 * 错误信息接口
 */
interface ErrorInfo {
  message: string
  name: string
  stack?: string
  timestamp: string
  environment: 'server' | 'client'
  url: string
  referer: string
  userAgent: string
  [key: string]: unknown
}

/**
 * 格式化错误信息
 * @param error 错误对象
 * @param customParams 自定义附加参数
 * @returns 格式化后的错误信息对象
 */
export const formatError = (error: Error, customParams: Record<string, unknown> = {}): ErrorInfo => {
  // 基础错误信息
  const errorInfo: ErrorInfo = {
    message: error?.message || '',
    name: error?.name || '',
    timestamp: new Date().toISOString(),
    environment: typeof window === 'undefined' ? 'server' : 'client',
    url: '',
    referer: '',
    userAgent: '',
    ...customParams,
  }

  // 客户端环境特有信息收集
  if (typeof window !== 'undefined') {
    try {
      errorInfo.url = window.location.href || ''
      errorInfo.referer = document.referrer || ''
      errorInfo.userAgent = window.navigator.userAgent || ''
    } catch (e) {
      console.warn('Error collecting client information:', e)
    }
  } else if (import.meta.server) {
    // 服务器端环境特有信息收集
    try {
      // 使用 useRequestHeaders 获取头信息
      const headers = useRequestHeaders(['referer', 'user-agent', 'host'])

      // 获取当前URL
      const event = useRequestEvent()
      const url = event?.node?.req?.url || ''

      // 设置信息
      errorInfo.url = `${headers.host || ''}${url}`
      errorInfo.referer = headers.referer || ''
      errorInfo.userAgent = headers['user-agent'] || ''
    } catch (e) {
      console.warn('Error collecting server information:', e, customParams)
      // 后备方案...
    }
  }
  return errorInfo
}

/**
 * 获取错误信息的字符串表示，用于日志输出
 * @param error 错误对象
 * @param customParams 自定义附加参数
 * @returns 格式化的错误信息字符串
 */
export const formatErrorString = (error: Error, customParams: Record<string, unknown> = {}): void => {
  const errorInfo = formatError(error, customParams)
  console.log(error)
  console.log(JSON.stringify(errorInfo, null, 2))
}
